const colors = {
  accent: '#DF5060',
  orange: '#FA968C',
  green: '#75BF72',
  lightAccent: 'rgba(243, 83, 74, 0.2)',
  select: 'rgba(20, 70, 150, 0.15)', // the select inputs
  lightGreen: 'rgba(33, 150, 83, 0.2)',
  // primary: 'rgb(52,122, 240)',
  primary: 'rgb(0,0, 0)',
  lightPrimary: 'rgba(47, 128, 237, 0.3)',
  primary2: 'rgb(27, 20, 100)',
  primary3: 'rgba(5, 53, 117, 1)',
  primary4: 'rgb(66, 202, 112)',
  lightPrimary2: 'rgba(27, 20, 100, 0.3)',
  secondary: 'rgb(253, 189, 94)',
  lightSecondary: 'rgba(243, 106, 2, 0.3)',
  // secondary1: 'rgb(193, 39, 45)',
  // secondary2: 'rgb(255, 229, 198)',
  // secondary3: 'rgb(191, 232, 0)',
  // secondary4: 'rgb(241, 200, 87)',
  illustration: 'rgb(237, 241, 249)',
  tertiary: 'rgb(41, 211, 69)',
  dull: 'rgb(250, 250, 250)',
  // black: 'rgba(0, 0, 0, 0.7)',
  black: 'rgb(14, 32, 59)',
  white: '#fff',
  offwhite: '#fffff1',
  // gray: 'rgb(153, 153, 153)',
  gray: 'rgb(173, 174, 174)',
  // gray: 'rgb(136, 146, 167)',
  gray2: 'rgb(235, 235, 235)',
  gray3: '#C5CCD6',
  formGray: 'rgb(170, 170, 170)',
  textGray: 'rgb(148, 149, 150)',
  cardGray: 'rgb(92, 141, 224)',
  colorinBlueCard: 'rgb(92, 141, 224)',
  colorInGreenCard: 'rgb(107, 198, 144)',
  caption: 'rgba(0, 0, 0, 0.7)',
  headerColor: '#000',
  active: '#007BFA',
  statusbar: '#08948c',
  iosDefault: '#0A60FF',
  stop: '#ff0000',
  lightGray: '#eee',
  transparent: 'transparent',
  social: {
    facebook: '#3b5998',
    twitter: '#00aced',
    pinterest: '#cb2027',
    linkedin: '#007bb6',
    youtube: '#bb0000',
    vimeo: '#aad450',
    tumblr: '#32506d',
    instagram: '#517fa4',
    quora: '#a82400',
    foursquare: '#0072b1',
    wordpress: '#21759b',
    stumbleupon: '#EB4823',
  },
};

const sizes = {
  // global sizes
  base: 16,
  font: 14,
  radius: 6,
  padding: 25,
  margin: 36,
  horizontal: 10,
  icon: 25,

  // font sizes
  h1: 26,
  h2: 20,
  h3: 18,
  title: 18,
  header: 16,
  body: 14,
  caption: 12,
  fit: 300,
};

const fonts = {
  h1: {
    fontSize: sizes.h1,
  },
  h2: {
    fontSize: sizes.h2,
  },
  h3: {
    fontSize: sizes.h3,
  },
  header: {
    fontSize: sizes.header,
  },
  title: {
    fontSize: sizes.title,
  },
  body: {
    fontSize: sizes.body,
  },
  caption: {
    fontSize: sizes.caption,
  },
};

export {colors, sizes, fonts};
